import { Error } from '../../error';
import { Input, Select } from '../../input';

const num = (val) => (val ? parseInt(val) : null);

export const CrawlOptionsInput = ({ params, onChange, errors }) => (
  <div style={{ display: 'flex', gap: 10 }}>
    <div>
      <Input
        style={{ width: 120 }}
        label="Max visits"
        value={params.maxVisits}
        onChange={(e) => onChange('maxVisits', num(e.target.value))}
        placeholder={`eg. "50"`}
      />
      <Error small message={errors?.maxVisits} />
    </div>

    <Select
      label="Max depth"
      value={params.maxDepth}
      onChange={(val) => onChange('maxDepth', num(val))}
      style={{ width: 120 }}
      choices={[
        [0, 0],
        [1, 1],
        [2, 2],
        [3, 3],
        [4, 4],
        [5, 5],
        [6, 6],
        [7, 7],
        [8, 8],
      ]}
    />

    <Select
      label="Concurrency"
      value={params.concurrency}
      onChange={(val) => onChange('concurrency', num(val))}
      style={{ width: 120 }}
      choices={[
        [10, 10],
        [50, 50],
        [200, 200],
        [400, 400],
      ]}
    />

    <Select
      label="Crawl strategy"
      value={params.crawlStrategy}
      onChange={(val) => onChange('crawlStrategy', val)}
      style={{ width: 120 }}
      choices={[
        ['bfs', 'Breadth first'],
        ['dfs', 'Depth first'],
        ['random', 'Random'],
      ]}
    />
  </div>
);
